var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLdOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.71 12.45a.517.517 0 00.807-.426.513.513 0 00-.22-.422.516.516 0 00-.587.849zm-.403-1.987L11.304 2l1.37.815 6.102 3.504c.279-.193.618-.307.984-.307a1.72 1.72 0 011.725 1.716c0 .68-.398 1.268-.975 1.546v7.799l-7.78 4.468-.714.41V22l-.706-.406-7.787-4.473-.02-7.652a1.715 1.715 0 01-.988-1.552A1.72 1.72 0 014.239 6.2a1.72 1.72 0 011.725 1.716c0 .704-.426 1.309-1.036 1.573l.02 6.812 6.361 3.654-.001-6.358a1.716 1.716 0 01-1.023-1.568c0-.698.42-1.3 1.022-1.567zm1.423 3.127v6.314l6.354-3.65V9.307a1.716 1.716 0 01-1.038-1.769L12.73 4.484v5.986a1.716 1.716 0 011.004 1.56c0 .692-.411 1.288-1.004 1.56zm6.513-5.862a.516.516 0 00.517.515.516.516 0 100-1.03.516.516 0 00-.517.515zM3.72 7.917c0 .284.232.514.518.514.286 0 .517-.23.517-.514a.516.516 0 00-.517-.515.516.516 0 00-.518.515z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLdOutline);
export default __webpack_public_path__ + "f8cf0cb371005b37cf444021d31bede8.svg";
export { ForwardRef as ReactComponent };